import "../../css/components/Collage.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import g from "../utils/globals";
import CollageItem from "./CollageItem";
import Logger from "../utils/Logger";
import { getRatio, isHomeMobile } from "../utils/helpers";
import { saveProps } from "../store/actions/index";
import Counter from "./Counter";

const logger = new Logger(__filename);

class Collage extends Component {
  constructor(...args) {
    super(...args);
    this.state = { items: [] };
  }

  componentDidMount = () => {
    if (this.props.willDuplicate && !this.props.clone) {
      this.props.saveProps(this.props.willDuplicate, this.props);
    }
    if (this.props.enhancement && !this.props.enhancement.Content) {
      this.loadEnhancement(this.props.enhancement, true);
      const fileName = this.props.dataAttrs["data-content"];
      const contentEnhancement = this.props.enhancement[fileName] || {};
      this.loadEnhancement(contentEnhancement);
    }
    this.computeItems(this.props);
  };

  componentWillReceiveProps = nextProps => {
    if (nextProps.active !== this.props.active) return true;
    if (nextProps.contents !== this.props.contents || this.state.items.length < 1) {
      this.computeItems(nextProps);
    }
  };

  shouldComponentUpdate = (nextProps, nextState) => this.state.items !== nextState.items;

  getCollageItems = () =>
    this.state.items.map((m, index) => {
      if (m.dataAttrs) {
        m.dataAttrs["data-content"] = this.props.dataAttrs ? this.props.dataAttrs["data-content"] : "";
      }
      if (m.id === "placeholder") {
        m.module = "HTML";
        m.attrs = {};
      }
      if (m.module === "Img" || m.module === "Video" || m.module === "Carousel") {
        m.carousel = this.props.carousel;
      }

      return (
        <CollageItem
          {...m}
          key={index}
          index={index}
          position={this.props.index}
          customHTML={this.props.customHTML}
          analytics={this.props.analytics}
          carousel={this.props.carousel}
          carouselIndex={this.props.carouselIndex}
          root={this.props.root}
          staticVideos={
            this.props.enhancement &&
            (this.props.enhancement.staticVideos ||
              (this.props.dataAttrs &&
                this.props.enhancement[m.dataAttrs["data-content"]] &&
                this.props.enhancement[m.dataAttrs["data-content"]].staticVideos))
          }
          noLazy={this.props.enhancement?.noLazy || this.props.enhancement?.[m?.dataAttrs?.["data-content"]]?.noLazy}
          playingVideos={this.props.enhancement?.playingVideos || this.props.enhancement?.[m?.dataAttrs?.["data-content"]]?.playingVideos}
          singleQualityVideos={
            this.props.enhancement?.singleQualityVideos || this.props.enhancement?.[m?.dataAttrs?.["data-content"]]?.singleQualityVideos
          }
        />
      );
    });

  loadEnhancement = (fn, once = false) => {
    if (!fn || !fn.init) return;
    if (!once || !g.enhancementsLoaded.includes(this.props.attrs.id)) {
      try {
        fn.init(this);
        logger.log(`... enhancing content [${this.props.attrs.id}]`);
        if (once) {
          g.enhancementsLoaded.push(this.props.attrs.id);
        }
      } catch (error) {
        logger.error(`Enhancement error: ${this.props.attrs.id}`);
        logger.debug(error);
      }
    }
  };

  computeItems = nextProps => {
    // TODO: revisar esto que parece que no hace el assign de customProps
    const items = nextProps.contents;
    if (items.length < 1) return;
    items.map((l, index) => Object.assign({ index }, Object.assign({}, l, l.customProps)));
    this.setState({ items });
  };

  render = () => {
    if (this.state.items.length < 1) return null;
    if (this.props.enhancement && this.props.enhancement.Content) {
      const Content = this.props.enhancement.Content;
      return (
        <div
          ref={el => {
            this.el = el;
          }}
          {...this.props.attrs}
        >
          <Content enhancement={this.props.enhancement} contents={this.props.contents} l10n={this.props.l10n} />
        </div>
      );
    }
    const style = {};
    if (!isHomeMobile()) {
      style.paddingBottom = `${getRatio(this.props.ratio)}%`;
    }
    if (this.props.bgColor) {
      style.backgroundColor = this.props.bgColor;
    }
    const itemsCollage = this.getCollageItems();

    return (
      <div
        ref={el => {
          this.el = el;
        }}
        {...this.props.attrs}
        style={style}
      >
        {this.props.customProps.counter ? (
          <Counter
            position={this.props.index}
            analytics={this.props.analytics}
            carousel={this.props.carousel}
            root={this.props.root}
            data={this.props.customProps.counter}
          >
            {itemsCollage}
          </Counter>
        ) : (
          itemsCollage
        )}
      </div>
    );
  };
}

Collage.defaultProps = {
  index: 0,
  carousel: null,
  carouselIndex: null,
  ratio: {
    desktop: 1,
    document: 1,
  },
};

Collage.propTypes = {
  carousel: PropTypes.bool,
  carouselIndex: PropTypes.number,
  contents: PropTypes.array.isRequired,
  l10n: PropTypes.shape({
    t: PropTypes.func,
  }),
  attributes: PropTypes.shape({
    l10n: PropTypes.shape({
      t: PropTypes.func,
    }),
  }),
  ratio: PropTypes.shape({
    desktop: PropTypes.number,
    document: PropTypes.number,
  }),
  attrs: PropTypes.object,
  products: PropTypes.object,
  index: PropTypes.number,
};

const mapDispatchToProps = dispatch => ({
  saveProps: (position, props) => dispatch(saveProps(position, props)),
});

export default connect(null, mapDispatchToProps)(Collage);
